<template>
    <input
        type="file"
        @change="onChange"
    />
</template>

<script>
export default {
    methods: {
        onChange(event) {
            const files = event.target.files || event.dataTransfer.files;
            if (!files.length) {
                return;
            }

            const reader = new FileReader();
            reader.onload = e => this.$emit('change', e.target.result);
            reader.readAsArrayBuffer(files[0]);
        }
    },
}
</script>
